import Typography from "@mui/material/Typography";
import React from "react";
import {AddButton} from "../buttons/AddButton";
import {Breakpoint, Theme} from "@mui/material/styles";
import {Box} from "@mui/material";
import Grid, {GridSize} from "@mui/material/Grid/Grid";
import {FormButtonBar} from "../forms/FormButtonBar";
import {WithRestrictedEdit} from "../../technical/security/WithRestrictedEdit";
import {SxProps} from "@mui/system";

export function ContentPageTableHeader(props: {
  onClick: () => void,
  title: React.ReactElement | string,
  titleButton: string,
  additionalHeaderItem?: React.ReactElement,
  sx?: SxProps<Theme>,
} & WithRestrictedEdit & Partial<Record<Breakpoint, boolean | GridSize>>) {
  const {
    onClick,
    title,
    titleButton,
    isEditable,
    additionalHeaderItem,
    sx,
    ...gridItemProps
  } = {...props}

  return (
      <Grid container={true} justifyContent="center" sx={sx}>
        <Grid item={true} xs={12} {...gridItemProps}>
          <Box sx={{display: 'flex', alignContent: 'center',}}>
            {(typeof title === 'string') ?
              <Typography variant={"h5"} sx={{ alignSelf: 'center', marginRight: 2, fontSize: '1.2rem', whiteSpace: 'nowrap' }}>{title}</Typography>
            :
              title
            }
            <FormButtonBar sx={{}}>
              {isEditable &&
                  <Grid item>
                      <AddButton onClick={onClick} title={titleButton} />
                  </Grid>
              }
              {additionalHeaderItem}
            </FormButtonBar>
          </Box>
        </Grid>
      </Grid>
  )
}
